/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesIt = {
  privacy: {
    pageTitle: "Informativa sulla privacy",
    lastUpdated: "Ultimo aggiornamento: 1 giugno 2026",
    introduction: {
      title: "Introduzione",
      body: "WasOK è un'applicazione di supporto allo shopping locale, progettata per aiutare gli utenti a ricordare i prodotti che hanno precedentemente acquistato, valutato o recensito.\n\nLa presente Informativa sulla privacy spiega quali informazioni vengono elaborate durante l'uso dell'app, come i dati vengono archiviati e come possono operare determinati servizi di terze parti.",
    },
    dataStored: {
      title: "Dati archiviati dall'app",
      body: "WasOK archivia le seguenti informazioni localmente sul tuo dispositivo:\n\n• codici a barre dei prodotti scansionati\n• nomi e dettagli dei prodotti inseriti dall'utente\n• valutazioni e commenti\n• liste della spesa\n• categorie di prodotti\n• prezzi e informazioni sui negozi\n• foto di prodotti e negozi\n\nI tuoi dati sui prodotti e le foto non vengono caricati sui server di WasOK.",
    },
    permissions: {
      title: "Autorizzazioni utilizzate",
      camera: {
        title: "Fotocamera",
        body: "L'accesso alla fotocamera è utilizzato per:\n\n• scansionare i codici a barre\n• scattare foto dei prodotti",
      },
      photos: {
        title: "Foto e media",
        body: "L'accesso alle foto o alla galleria è utilizzato solo quando:\n\n• alleghi immagini ai prodotti\n• ripristini backup contenenti foto",
      },
      files: {
        title: "Accesso a file e archiviazione",
        body: "L'accesso ai file può essere utilizzato per:\n\n• esportare file di backup\n• importare backup selezionati dall'utente\n• condividere liste della spesa o backup",
      },
    },
    backup: {
      title: "Backup ed esportazione",
      body: "WasOK consente agli utenti di creare file di backup contenenti i dati dell'app e, opzionalmente, le foto.\n\nI file di backup vengono creati localmente sul tuo dispositivo e possono essere archiviati o condivisi tramite servizi scelti dall'utente, ad esempio:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• archiviazione locale del dispositivo\n\nWasOK non carica i backup sui propri server.",
      onlineProductLookup: {
        title: "Ricerca prodotti online",
        body: "Quando abiliti la ricerca online dei codici a barre nelle Preferenze, WasOK può inviare solo il numero del codice a barre scansionato a database pubblici di prodotti (come Open Food Facts) per suggerire nome e marca del prodotto. WasOK non carica le tue valutazioni, commenti, foto, liste della spesa, categorie, informazioni sui negozi o dati di backup per questa funzione. Puoi disattivarla in qualsiasi momento nelle Preferenze.",
      },
    },
    advertising: {
      title: "Pubblicità e servizi di terze parti",
      intro:
        "WasOK utilizza servizi di terze parti selezionati per fornire determinate funzionalità.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob è utilizzato per visualizzare annunci all'interno dell'app.\n\nGoogle e i suoi partner possono elaborare informazioni quali:\n\n• identificatori pubblicitari\n• informazioni sul dispositivo\n• indirizzo IP\n• dati diagnostici e di utilizzo\n\nGli utenti in determinate regioni potrebbero essere invitati a dare il consenso prima della visualizzazione di annunci personalizzati.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK utilizza Firebase Crashlytics per identificare i crash e migliorare la stabilità dell'app.\n\nI report di crash possono includere informazioni tecniche quali:\n\n• modello del dispositivo\n• versione del sistema operativo\n• versione dell'app\n• diagnostica dei crash\n\nI report di crash non includono intenzionalmente le tue valutazioni dei prodotti, note, liste della spesa o foto.",
      },
      externalProductDatabases: {
        title: "Database di prodotti esterni",
        body: "La funzionalità di ricerca dei codici a barre può utilizzare database di prodotti esterni per recuperare informazioni sui prodotti.\n\nPer ulteriori informazioni, consulta le informative sulla privacy dei rispettivi fornitori.",
      },
    },
    dataSecurity: {
      title: "Sicurezza dei dati",
      body: "WasOK archivia i dati dell'app localmente sul tuo dispositivo utilizzando i meccanismi di archiviazione forniti dal sistema operativo.\n\nSebbene vengano adottate misure ragionevoli per proteggere i dati locali dell'app, nessun metodo di archiviazione elettronica è completamente sicuro.\n\nGli utenti sono responsabili della conservazione dei backup dei dati importanti, se lo desiderano.",
    },
    children: {
      title: "Privacy dei minori",
      body: "WasOK non è destinato a bambini di età inferiore ai 13 anni.",
    },
    notifications: {
      title: "Notifiche",
      body: "WasOK può opzionalmente creare notifiche locali sul tuo dispositivo per ricordarti di valutare i prodotti dopo l'acquisto.\n\nQueste notifiche vengono generate e programmate localmente sul tuo dispositivo e non richiedono un account o un server remoto.\n\nPuoi disattivare le notifiche in qualsiasi momento dalle impostazioni del dispositivo o dall'app, se supportato.",
    },
    yourControl: {
      title: "Il tuo controllo sui dati",
      body: "Puoi:\n\n• modificare o eliminare i prodotti archiviati in qualsiasi momento\n• cancellare i dati dell'app dal tuo dispositivo\n• disinstallare l'app\n• esportare i backup dei tuoi dati",
    },
    changes: {
      title: "Modifiche a questa informativa",
      body: "La presente Informativa sulla privacy può essere aggiornata di tanto in tanto.\n\nLe modifiche diventano efficaci quando viene pubblicata la versione aggiornata.",
    },
    contact: {
      title: "Contatti",
      body: "Per domande relative a questa Informativa sulla privacy, contatta:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Termini di servizio",
    lastUpdated: "Ultimo aggiornamento: 1 giugno 2026",
    acceptance: {
      title: "Accettazione dei termini",
      body: "Scaricando, installando o utilizzando WasOK, accetti i presenti Termini di servizio.\n\nSe non accetti questi Termini, non dovresti utilizzare l'app.",
    },
    license: {
      title: "Licenza",
      body: "WasOK ti concede una licenza limitata, non esclusiva, non trasferibile e revocabile per utilizzare l'app in conformità con i presenti Termini.",
    },
    acceptableUse: {
      title: "Uso consentito",
      body: "Accetti di non:\n\n• abusare dell'app\n• interferire con il funzionamento dell'app\n• tentare di effettuare reverse engineering o modificare l'app\n• utilizzare l'app in violazione delle leggi o dei regolamenti applicabili",
    },
    localData: {
      title: "Dati locali e backup",
      body: "WasOK archivia i dati dell'utente localmente sul dispositivo.\n\nGli utenti sono responsabili della conservazione dei backup dei dati importanti, se lo desiderano.\n\nSebbene possano essere fornite funzionalità di backup e ripristino, WasOK non garantisce contro la perdita, la corruzione o il guasto dei dati archiviati.",
    },
    advertisements: {
      title: "Pubblicità",
      body: "L'app può visualizzare annunci forniti da partner pubblicitari di terze parti, tra cui Google AdMob.",
    },
    noWarranty: {
      title: "Nessuna garanzia",
      body: "WasOK è fornito \"così com'è\" e \"come disponibile\" senza garanzie di alcun tipo, espresse o implicite.\n\nNon garantiamo che:\n\n• l'app sia sempre disponibile\n• l'app sia priva di errori\n• non si verifichi mai la perdita di dati\n• tutte le funzionalità operino senza interruzioni su tutti i dispositivi",
    },
    limitationLiability: {
      title: "Limitazione di responsabilità",
      body: "Nella misura massima consentita dalla legge, WasOK e i suoi sviluppatori non saranno responsabili per:\n\n• perdita di dati\n• perdita di profitti\n• problemi al dispositivo\n• danni indiretti o consequenziali\n• interruzioni derivanti dall'uso o dall'impossibilità di usare l'app",
    },
    thirdParty: {
      title: "Servizi di terze parti",
      body: "Alcune funzionalità o contenuti possono basarsi su servizi di terze parti, tra cui fornitori di pubblicità e servizi di archiviazione/condivisione esterni selezionati dall'utente.\n\nWasOK non è responsabile dei servizi di terze parti né delle loro politiche.",
    },
    productInformation: {
      title: "Informazioni sui prodotti",
      body: "Alcuni dettagli sui prodotti possono essere ottenuti da servizi di ricerca di codici a barre di terze parti.\n\nWasOK non garantisce l'accuratezza, la completezza, la disponibilità o l'idoneità delle informazioni fornite da fonti di dati esterne.\n\nGli utenti dovrebbero verificare autonomamente le informazioni sui prodotti quando necessario.",
    },
    changesApp: {
      title: "Modifiche all'app",
      body: "WasOK può essere modificato, aggiornato, sospeso o interrotto in qualsiasi momento senza preavviso.",
    },
    changesTerms: {
      title: "Modifiche a questi termini",
      body: "I presenti Termini possono essere aggiornati periodicamente.\n\nL'uso continuato dell'app dopo l'entrata in vigore degli aggiornamenti costituisce accettazione dei Termini rivisti.",
    },
    contact: {
      title: "Contatti",
      body: "Per domande relative a questi Termini, contatta:\n\nsupport@wasok.app",
    },
  },
};
